export enum ToothEditorModalActions {
    Delete = 0,
    Apply = 1
}